import React, { useEffect, useState } from 'react';
import Match from "../components/Match";
import { 
    fetchMatches, 
    fetchPredictPageTournaments, 
    fetchActiveTournaments 
} from "../api/api.js";
import {
    getActiveTournaments,
    getTournamentDisplayName
} from "../utils/tournamentUtils";

function Predict() {
    const [matchData, setMatchData] = useState([]);
    const [tournaments, setTournaments] = useState([]);
    const [fixtures, setFixtures] = useState(["Next games"]);
    const [selectedFixture, setSelectedFixture] = useState("Next games");
    const [selectedTournament, setSelectedTournament] = useState(() => {
            const saved = localStorage.getItem("predict-filter");
            return saved && saved !== "all" ? saved : "all";
        });
    const [currentFixture, setCurrentFixture] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadMatches = async (tournament, fixture) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetchMatches(tournament, fixture);
            setMatchData(response.data.games);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const loadTournaments = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetchPredictPageTournaments();
            let loaded = response.data.tournaments;

            if (loaded.length > 1) {
                loaded = [{ id: "all", name: "All", fixtures: [] }, ...loaded];
            }

            setTournaments(loaded);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleTournamentChange = (newTournament) => {
        const newFixture = "Next games"; // Always reset fixture when switching tournaments
        setSelectedTournament(newTournament);
        setSelectedFixture(newFixture);

        // Call API only once with updated tournament and fixture
        loadMatches(newTournament, newFixture);
    };

    const handleFixtureChange = (newFixture) => {
        setSelectedFixture(newFixture);
        loadMatches(selectedTournament, newFixture);
    };

    useEffect(() => {
        loadTournaments();
    }, []);

    useEffect(() => {
        if (!tournaments.length) return;
        loadMatches(selectedTournament, selectedFixture);
    }, [tournaments]);

    useEffect(() => {
            localStorage.setItem("predict-filter", selectedTournament);
        }, [selectedTournament]);

    useEffect(() => {
        if (!tournaments.length) {
            return
        } else if (tournaments.length == 1) {
            localStorage.setItem("predict-filter", tournaments[0].id);
            setSelectedTournament(tournaments[0].id)
        };

        if (selectedTournament === "all") {
            setFixtures(["Next games"]);
            setCurrentFixture(null);
            return;
        }

        const t = tournaments.find(t => t.id == selectedTournament);
        setFixtures(["Next games", ...(t?.fixtures ?? [])]);
        setCurrentFixture(t?.current_fixture ?? null);

    }, [tournaments, selectedTournament]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
            <div className="content-container">
                <div className="filter-dropdown-container">
                    <div className="filter-dropdown-group">
                        <select 
                            value={selectedTournament} 
                            onChange={(e) => handleTournamentChange(e.target.value)} 
                            className="filter-dropdown white wdt-200"
                        >
                            {tournaments.map((tournament, index) => (
                                <option key={index} value={tournament.id}>{getTournamentDisplayName(tournament.name)}</option>
                            ))}
                        </select>
                        
                        <select 
                            value={selectedFixture} 
                            onChange={(e) => handleFixtureChange(e.target.value)} 
                            className="filter-dropdown white wdt-200"
                        >
                            {fixtures.map((fixture, index) => (
                                <option key={index} value={fixture}>
                                    {fixture}{fixture == currentFixture ? "*" : ""}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
    
                <div className="predict matches">
                    {matchData.length > 0 ? (
                        matchData.map((match) => <Match key={match.id} match={match} />)
                    ) : (
                        <p>No matches available.</p>
                    )}
                </div>
            </div>
        );
}

export default Predict;